import request from "@helpers/request";
import qs from "qs";

function fetchMoList(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/x-www-form-urlencoded" })
    .build()
    .post(`/v1/cm/mo_list`, qs.stringify(data), { ...config });
}

function fetchAttributeList(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/x-www-form-urlencoded" })
    .build()
    .post(`/v1/cm/attribute_list`, qs.stringify(data), { ...config });
}
function RetCompare(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/cm/irancell/ret/compare`, data, { ...config });
}
function RetAvailableDate(config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .get(`/v1/cm/irancell/ret/available_dates`, { ...config });
}
function fetchViewList(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/x-www-form-urlencoded" })
    .build()
    .post(`/v1/cm/view`, qs.stringify(data), { ...config });
}

function downloadMoDump(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/x-www-form-urlencoded" })
    .build()
    .post(`/v1/cm/download`, qs.stringify(data), {
      ...config,
      timeout: 30 * 1000,
    });
}

function compareMo(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/x-www-form-urlencoded" })
    .build()
    .post(`/v1/cm/compare`, qs.stringify(data), {
      ...config,
      timeout: 30 * 1000,
    });
}

function fetchAlertList(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/x-www-form-urlencoded" })
    .build()
    .get(`/v1/cm/alerts`, qs.stringify(data), { ...config });
}

function createAlert(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/x-www-form-urlencoded" })
    .build()
    .post(`/v1/cm/alerts`, qs.stringify({ ...data }), {
      ...config,
    });
}

function deleteAlert(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/x-www-form-urlencoded" })
    .build()
    .delete(`/v1/cm/alerts`, {}, { ...config, data: qs.stringify(data) });
}
function brtel_mci_link_add(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/cm/brtel_mci/link/add`, data, { ...config });
}
function brtel_mci_link_list(config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .get(`/v1/cm/brtel_mci/link/list`, { ...config });
}

function brtel_mci_mo_list(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/cm/brtel_mci/mo/list`, data, { ...config });
}
function brtel_mci_available_dates(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/cm/brtel_mci/availableDates`, data, { ...config });
}
function brtel_mci_download(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/x-www-form-urlencoded" })
    .build()
    .post(`/v1/cm/brtel_mci/download`, qs.stringify(data), {
      ...config,
      timeout: 300 * 1000,
    });
}
function Rightel_download(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/x-www-form-urlencoded" })
    .build()
    .post(`/v1/cm/rightel/download`, qs.stringify(data), {
      ...config,
      timeout: 300 * 1000,
    });
}
function brtel_mci_cell_in_pm_check(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/cm/brtel_mci/cell_in_pm_check`, data, { ...config });
}
function brtel_mci_compare(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/cm/brtel_mci/compare`, data, { ...config });
}
const baseUrl = "/v1/cm";
function Post(address, params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`${baseUrl}${address}`, params, { ...config });
}
function Get(address, params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .get(`${baseUrl}${address}`, params, { ...config });
}
function PostBlob(address, params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`${baseUrl}${address}`, params, { ...config, responseType: "blob" });
}
function PostForm(address, params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "multipart/form-data" })
    .build()
    .post(`${baseUrl}${address}`, params, { ...config });
}
function GetBlob(address, params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .get(`${baseUrl}${address}`, params, { ...config, responseType: "blob" });
}
const configurationManagementService = {
  Get,
  Post,
  PostBlob,
  GetBlob,
  PostForm,
  brtel_mci_cell_in_pm_check,
  brtel_mci_compare,
  brtel_mci_mo_list,
  brtel_mci_download,
  brtel_mci_available_dates,
  fetchMoList,
  fetchViewList,
  fetchAttributeList,
  downloadMoDump,
  compareMo,
  fetchAlertList,
  createAlert,
  deleteAlert,
  RetCompare,
  RetAvailableDate,
  brtel_mci_link_add,
  brtel_mci_link_list,
  Rightel_download,
};

export default configurationManagementService;
